export enum PLAYLIST {
    /**
     * @value Do you want to add the playlist to the video gallery?
     * @description In the notification dialog, when a new playlist is created we ask the user if he want to add the playlist to the gallery.
     * "Playlist" should not be translated.
     */
    ADD_PLAYLIST_TO_GALLERY = 'PLAY.ADD_PLAYLIST_TO_GALLERY',
    /**
     * @value Add to playlist
     */
    ADD_TO_PLAYLIST = 'PLAY.ADD_TO_PLAYLIST',
    /**
     * @value Adjust the smart playlist parameters to add videos to the playlist.
     * @description "Playlist" should not be translated.
     */
    ADD_VIDEOS_TO_DYNAMIC_PLAYLIST = 'PLAY.ADD_VIDEOS_TO_DYNAMIC_PLAYLIST',
    /**
     * @value Add a collection of videos to your playlist
     * @description Text used to prompt the user to add videos to a playlist
     */
    ADD_VIDEOS_TO_PLAYLIST = 'PLAY.ADD_VIDEOS_TO_PLAYLIST',
    /**
     * @value Any time
     * @description Option into a select field to pick videos from any time in smart playlist.
     * In French: Date indifférente
     */
    ANY_TIME = 'PLAY.SINCE_ANY_TIME',
    /**
     * @value Auto play
     * @description Switch label to enable the auto play on playlist
     */
    AUTO_PLAY = 'PLAY.AUTO_PLAY',
    /**
     * @value This playlist will be displayed if the query matches the video.
     */
    AVAILABILITY_SEARCH_DESCRIPTION = 'PLAY.AVAILABILITY_PLAYLIST_SEARCH_DESCRIPTION',
    /**
     * @value This playlist contains all videos that:
     * @description Description to help user to configure the smart playlist
     */
    CONTAINS_VIDEO = 'PLAY.PLAYLIST_CONTAINS_VIDEO',
    /**
     * @value Create playlist
     * @description Text that can be use to label a button allowing ours users to create a new videos playlist
     */
    CREATE = 'PLAY.CREATE_PLAYLIST',
    /**
     * @value The playlist has been deleted
     * @description This text appears in a notification when a user delete a playlist
     */
    DELETED = 'PLAY.PLAYLIST_DELETED',
    /**
     * @value {"one":"Delete playlist?","other":"Delete %NB% playlists?"}
     * @description Text used to ask the user to confirm the deletion of one or more playlists.
     */
    DELETE_CONFIRM = 'PLAY.DELETE_PLAYLISTS_CONFIRM',
    /**
     * @value {"one":"Delete playlist","other":"Delete %NB% playlists"}
     * @description Text used to label a button allowing the user to delete one or several playlists
     */
    DELETE_CTA = 'PLAY.DELETE_PLAYLISTS',
    /**
     * @value {"one":"This playlist will be permanently deleted.\nThe videos it contains will not be deleted.","other":"The selected playlists will be permanently deleted.\nThe videos they contain will not be deleted."}
     * @description Text used to explain to the user what are the consequences of deleting one or more playlists
     */
    DELETE_MESSAGE = 'PLAY.DELETE_PLAYLISTS_MESSAGE',
    /**
     * @value Smart
     * @description The type of playlist the user can choose when he creates a new one.
     */
    DYNAMIC = 'PLAY.SMART_PLAYLIST',
    /**
     * @value Add automation in picking videos
     * @description Text helper from the radio below that explains how works smart playlists
     */
    DYNAMIC_HELPER = 'PLAY.SMART_PLAYLIST_HELPER',
    /**
     * @value Edit playlist
     */
    EDIT_PLAYLIST = 'PLAY.EDIT_PLAYLIST',
    /**
     * @value Edit playlist author
     */
    EDIT_PLAYLIST_AUTHOR = 'PLAY.EDIT_PLAYLIST_AUTHOR',
    /**
     * @value Enter a short description of the playlist
     * @description Text use in the placeholder description field of a playlist
     */
    ENTER_DESCRIPTION = 'PLAY.ENTER_PLAYLIST_DESCRIPTION',
    /**
     * @value Enter the title of the playlist
     * @description Text used for example on an input field to ask our users to fill the title of a video playlist.
     */
    ENTER_TITLE = 'PLAY.ENTER_PLAYLIST_TITLE',
    /**
     * @value Horizontal videos
     * @description Horizontal video button
     */
    HORIZONTAL_VIDEOS = 'PLAY.HORIZONTAL_VIDEOS',
    /**
     * @value Include
     * @description Subtitle to tell users how to include videos in the smart playlist
     */
    INCLUDE = 'PLAY.PLAYLIST_INCLUDE',
    /**
     * @value Allow publication of this playlist on this site
     */
    INTEGRATION_IN_SITE_TITLE = 'PLAY.INTEGRATION_PLAYLIST_IN_SITE_TITLE',
    /**
     * @value Link to the playlist
     * @description Text used to indicated the url below is for the playlist page
     */
    LINK = 'PLAY.PLAYLIST_LINK',
    /**
     * @value List options
     */
    LIST_OPTIONS = 'PLAY.LIST_OPTIONS',
    /**
     * @value Manual
     * @description The type of playlist the user can choose when he creates a new one
     */
    MANUAL = 'PLAY.MANUAL_PLAYLIST',
    /**
     * @value Pick videos manually
     * @description Text helper from the radio below that explains how works manual playlists
     */
    MANUAL_HELPER = 'PLAY.MANUAL_PLAYLIST_HELPER',
    /**
     * @value Matches all of
     * @description Option in a select field to match tags
     */
    MATCH_ALL = 'PLAY.MATCH_ALL',
    /**
     * @value Matches one of
     * @description Option in a select field to match tags
     */
    MATCH_ONE = 'PLAY.MATCH_ONE',
    /**
     * @value New playlist
     * @description Text used for example on as a title of a dialog allowing our users to create a new playlist.
     * "Playlist" should not be translated.
     */
    NEW = 'PLAY.NEW_PLAYLIST',
    /**
     * @value There are no playlists
     * @description Text used to tell our users that their video library does not contain any playlists
     */
    NO_PLAYLIST = 'PLAY.NO_PLAYLIST',
    /**
     * @value Open playlist
     * @description Tooltip text that explain if the user click on the thumbnail it will open the playlist page
     */
    OPEN_PLAYLIST = 'PLAY.OPEN_PLAYLIST',
    /**
     * @value Order videos by
     * @description Label for video sort select
     */
    ORDER_VIDEOS_BY = 'PLAY.ORDER_VIDEOS_BY',
    /**
     * @value Playlist parameters
     * @description Title of the playlist parameters dialog
     */
    PARAMETERS = 'PLAY.PLAYLIST_PARAMETERS',
    /**
     * @value Past 24 hours
     * @description Label used by the search to display a date range
     */
    PAST_DAY = 'FRONT.SEARCH_FILTERS.DATE_RANGE.LAST_DAY',
    /**
     * @value Past month
     * @description Label used by the search to display a date range
     */
    PAST_MONTH = 'FRONT.SEARCH_FILTERS.DATE_RANGE.LAST_MONTH',
    /**
     * @value Past week
     * @description Label used by the search to display a date range
     */
    PAST_WEEK = 'FRONT.SEARCH_FILTERS.DATE_RANGE.LAST_WEEK',
    /**
     * @value Past year
     * @description Label used by the search to display a date range
     */
    PAST_YEAR = 'FRONT.SEARCH_FILTERS.DATE_RANGE.LAST_YEAR',
    /**
     * @value Pick all videos from
     * @description Label of sites multi-select
     */
    PICK_VIDEOS_FROM = 'PLAY.PICK_VIDEOS_FROM',
    /**
     * @value Pick videos since
     * @description Label for the date selector
     */
    PICK_VIDEOS_SINCE = 'PLAY.PICK_VIDEOS_SINCE',
    /**
     * @value Playlist
     * @description Text used to label a playlist (video playlist)
     */
    PLAYLIST = 'PLAY.PLAYLIST',
    /**
     * @value Playlists
     * @description Text used has a title to indicate user can see the playlists
     */
    PLAYLISTS = 'PLAY.PLAYLISTS',
    /**
     * @value Playlist authors changed
     * @description Text used to notify the user that he successfully changed playlist authors
     */
    PLAYLIST_AUTHORS_CHANGED = 'PLAY.PLAYLIST_AUTHORS_CHANGED',
    /**
     * @value The playlist author has edition rights on the video playlist. Their name will be displayed on the video playlist details.
     * @description Help text explaining to the user what a video playlist author can do.
     */
    PLAYLIST_AUTHOR_HELPER = 'PLAY.PLAYLIST_AUTHOR_HELPER',
    /**
     * @value Play the next video automatically
     * @description Tooltip for play next video automatically
     */
    PLAY_NEXT_VIDEO_AUTO = 'PLAY.PLAY_NEXT_VIDEO_AUTO',
    /**
     * @value Remove from the playlist
     * @description Title of an action inside a dropdown. Used to remove a video from the current playlist. To be more specific than just DELETE. User can be scared the video is really delete from the platform.
     */
    REMOVE_VIDEO_FROM_PLAYLIST = 'PLAY.REMOVE_VIDEO_FROM_PLAYLIST',
    /**
     * @value Restricted video
     * @description Test used when a video from a playlist is not available for the user
     */
    RESTRICTED_VIDEO = 'PLAY.RESTRICTED_VIDEO',
    /**
     * @value The changes have been saved
     * @description This text appears in a notification after the user made modification on playlist and click on save button
     */
    SAVED = 'PLAY.PLAYLIST_SAVED',
    /**
     * @value Save video
     */
    SAVE_VIDEO = 'PLAY.SAVE_VIDEO',
    /**
     * @value {"one":"You selected %NB_PLAYLIST% playlists from 1 author.","other":"You selected %NB_PLAYLIST% playlists from %NB_AUTHOR% authors."}
     * @description Shows the user the number of playlists selected and the number of playlist authors.
     */
    SELECTED_NB_PLAYLIST_FROM_NB_AUTHOR = 'PLAY.SELECTED_NB_PLAYLIST_FROM_NB_AUTHOR',
    /**
     * @value You selected 1 playlist from 1 author.
     * @description Tells the user he selected one playlist from one author.
     */
    SELECTED_PLAYLIST_FROM_AUTHOR = 'PLAY.SELECTED_PLAYLIST_FROM_AUTHOR',
    /**
     * @value Playlist thumbnail
     * @description Thumbnail alternative description for screen reader.
     */
    THUMBNAIL = 'PLAY.PLAYLIST_THUMBNAIL',
    /**
     * @value Updated
     */
    UPDATED = 'GLOBAL.UPDATED',
    /**
     * @value Updated on
     */
    UPDATED_ON = 'GLOBAL.UPDATED_ON',
    /**
     * @value Uploaded on
     * @description Display the date of the upload
     */
    UPLOADED_ON = 'PLAY.VIDEO_LIST_ITEM_UPDATED_AT',
    /**
     * @value Vertical videos
     * @description Vertical videos button
     */
    VERTICAL_VIDEOS = 'PLAY.VERTICAL_VIDEOS',
    /**
     * @value You don't have access to this video
     * @description Text used when a video from a playlist is not available for the user
     */
    VIDEO_VISIBILITY_RESTRICTED = 'PLAY.VIDEO_VISIBILITY_RESTRICTED',
    /**
     * @value The visibility of the playlist depends on the visibility of the videos it contains.
     *
     * Users who have no permission to access at least one video in the playlist, cannot see the playlist widget, open the playlist detail page, or search for the playlist.
     */
    VISIBILITY_DESCRIPTION = 'PLAY.VISIBILITY_DESCRIPTION',
    /**
     * @value Watch all
     * @description A link to the page where all videos of the current playlist can be watched
     */
    WATCH_ALL = 'PLAY.WATCH_ALL',
    /**
     * @value Only Play contributors and administrators can be playlist authors.
     * @description Helper text telling the user what types of users can author playlist podcasts
     */
    WHO_CAN_BE_PLAYLIST_AUTHOR = 'PLAY.WHO_CAN_BE_PLAYLIST_AUTHOR',
}
